export default __webpack_public_path__ + "static/Hero_v2-5f3a5a6fd46bb05ebd4ba98d83f9bbb8.mp4";